import { render, staticRenderFns } from "./ExpedienteCreateComiteView.vue?vue&type=template&id=dbd235d0&scoped=true&"
import script from "./ExpedienteCreateComiteView.vue?vue&type=script&lang=js&"
export * from "./ExpedienteCreateComiteView.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteCreateComiteView.vue?vue&type=style&index=0&id=dbd235d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd235d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCheckbox,
  VDataTable,
  VDivider,
  VFlex,
  VIcon,
  VProgressCircular,
  VSpacer,
  VTextarea,
  VToolbar,
  VToolbarTitle,
  VTooltip,
})
